/** Dispatched on `window` after preferences persist successfully (server or anon draft). */
export const PREFERENCES_SAVED_EVENT = "fg:preferences-saved";

export function notifyPreferencesSaved(): void {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(PREFERENCES_SAVED_EVENT));
  }
}
